import { AfterViewInit, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { SupportService } from 'src/app/services/core/support/support.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
// import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { debounceTime, filter, forkJoin, Subject} from 'rxjs';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { timeZone } from 'src/app/utils/utils.common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CsvService } from 'src/app/services/csv-service/csv.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { sweetAlert } from 'src/app/utils/swal';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { UserPermission } from 'src/app/enums/enums';
import { FilterPipe } from 'src/app/pipes/list-filter-pipe/list-filter-pipe';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SocketService } from 'src/app/services/app/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { includes } from 'lodash';
import { PaymentsService } from 'src/app/services/core/payments/payments.service';


@UntilDestroy()
@Component({
  selector: 'app-trip-list',
  templateUrl: './trip-list.component.html',
  styleUrls: ['./trip-list.component.css']
})
export class TripListComponent implements OnInit, OnDestroy, AfterViewInit {
  isTripDetailModal: boolean = false;
  selectedTrips: any = [];
  tripId: any;
  isDistributionModal = false;
  search: any = '';
  trips: any = [];
  fundingSources:any;
  spacetypes: any;
  preSpacetypes: any = {};
  preServiceAreas: any = {};
  // preMembers: any = {};
  preAppointmentType: any = {};
  preCompanies: any = {};
  preLevelOfService:any = {};
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS
  isItemsPerPageOpen = false;
  pageSizeOptions: number[] = [50,100,200,300,400,500];
  selectedStatus: any = 'pending';
  todayDate:any = [];
  startDate:any;
  endDate:any;
  levelofservices:any;
  selectedCompany = '';
  companies:any;
  serviceAreas : any;
  selectedServiceArea:any = ''
  selectedPendingStatus:any = ''
  selectedSpaceType:any = ''
  cancelTripObj:any;
  memberNotesObj:any;
  isMultiCancelModal = false;
  selectedDropdownIndex:any;
  toggleActionButtons = false;
  isDropdownOpen = false;
  user:any;
  preFundingSource:any = {};
  timeZone:any = timeZone;
  currentDate:any = moment().tz(this.timeZone).toISOString()
  tripDistributionModalObj: any;
  singleTrip: any;
  isAutoDistributionModal:any;
  userPermission=UserPermission;
  filterdataList:any= [];
  members:any = [];
  selectedMembers: any = '';
  memberSearchQuery: any;
  private readonly memberSearchSubject = new Subject<string | undefined>();
  memberPageNumber = 1;
  memberSearchPageNumber = 1;
  tripTrailId:any;
   source:any ='';
  isShowTime = false;
  logObj:any;
  private searchSubject = new Subject<string>();
  signatureModalObj: any;
  willCallModal:any = false
  willCallTrip:any
  rejectTripModalObj: any;
  notificationTrip:any;
  selectedFundingSource = '';
  relationLegObj: any = null;
  // trip id, its vendor, funding source or member are picked in the modal
  ticketTripId: string | null = null;





  constructor(
    private supportService: SupportService,
    private sharedDataService: SharedDataService,
    private serviceArea : ServiceAreasService,
    private credentialService : CredentialService,
    private levelOfService : LosService,
    private appointmentService: AppointmentTypeService,
    // private memberService: MemberService,
    private SpaceTypeService: SpaceTypeService,
    private tripService: TripService,
    private router: Router,
    private csvService: CsvService,
    private fundingSourceService: FundingSourceService,
    public permissionService: PermissionService,
    private memberService: MemberService,
    private socketService: SocketService,
    private route: ActivatedRoute,
    private paymentsService: PaymentsService
  ) {

  }
  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.setupFragment(); // calling order matters
    this.getUser();
    this.getFundingSources()
    this.getAllMembers();
    this.listenMemberSearch();
    this.initializeSearch();
  }

  setupFragment() {
    const fragment = this.route.snapshot.fragment;
    if (fragment) {
      this.selectedStatus = fragment;
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        fragment: this.selectedStatus
      });
    }
    setTimeout(() => {
      this.route.fragment.subscribe(fragment => {
        if (!fragment) {
          // case: trips menu is already activated and it is clicked again in the sidenav
          this.filterTrips("pending");
        } else {
          // case: click on the trip notification in notification modal
          if (this.selectedStatus !== fragment) {
            this.filterTrips(fragment);
          }
        }
      });
    }, 1000);
    this.getNotificationTrip();
  }

  getNotificationTrip() {
    this.sharedDataService.getTripRedirect()
      .pipe(untilDestroyed(this))
      .subscribe(trip => {
        if (trip) {
           this.clearFilters();
          this.search = trip.reference;
          // --- Auto-set date range in date picker ---
          if (trip.pickup?.time && trip.destination?.time) {
          const start = moment(trip.pickup.time).startOf('day');
          const end = moment(trip.destination.time).endOf('day');
          this.todayDate = [start, end];
        }
          this.tripId = trip.id
          this.sharedDataService.setTripRedirect(null);
        }
      });
  }

  clearFilters(){
    this.selectedCompany = ''
    this.selectedMembers = ''
    this.selectedPendingStatus = ''
    this.selectedServiceArea = ''
    this.selectedSpaceType = ''
    this.selectedFundingSource = ''
    
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).endOf("day"),
        ];
        this.loadInitialData();
      }

    })
  }

  loadInitialData() {
    const queryparams = {
      limit: 9999,
      isActive: 'true'
    }
    forkJoin({
      companies: this.credentialService.getPicker(queryparams),
      levelOfService: this.levelOfService.getPicker(queryparams),
      appointments: this.appointmentService.getPicker(queryparams),
      // members: this.memberService.getPickerMembers(queryparams),
      spaceTypes: this.SpaceTypeService.getPicker(queryparams),
      serviceAreas: this.serviceArea.getPicker(queryparams)
    }).pipe(untilDestroyed(this))
      .subscribe(({ companies, levelOfService, appointments, members, spaceTypes, serviceAreas }: any) => {

        //  Companies
        if (companies?.results?.length) {
          this.companies = companies.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Level of Service
        if (levelOfService?.results?.length) {
          this.preLevelOfService = levelOfService.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Appointments
        if (appointments?.results?.length) {
          this.preAppointmentType = appointments.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Members
        // if (members?.results?.length) {
        //   this.preMembers = members.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        // }

        //  Space Types
        if (spaceTypes?.results?.length) {
          this.spacetypes = spaceTypes.results;
          this.preSpacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  serviceAreas
        if (serviceAreas?.results?.length) {
          this.serviceAreas = serviceAreas.results
          this.preServiceAreas = serviceAreas.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Trips 
        this.getAllTrips(this.currentPage);
      });
  }
  

  getAllTrips(page: any) {
    this.clear();
    let queryparams: any = {
      limit: this.numberOfRecords,
      page,
      status: this.selectedStatus,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      company: this.selectedCompany || undefined,
      fundingsource: this.selectedFundingSource || undefined,
      sortBy: 'pickup.time:asc',
      // spaceType: this.selectedSpaceType,
      // serviceArea: this.selectedServiceArea
    }
    if (this.selectedStatus === 'all') {
      queryparams.status = [
        'pending',
        'scheduled',
        'offered',
        'completed',
        'cancelled',
        'onway',
        'arrived',
        'in_progress',
        'marketplace',
        'reroute'
      ];
    } else {
      queryparams.status = this.selectedStatus;
    }
    if (!this.selectedCompany) {
      delete queryparams.company;
    }
    if (!this.selectedFundingSource) {
      delete queryparams.fundingsource
    }
    if (this.selectedMembers) {
      queryparams.member = this.selectedMembers;
    }
    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryparams.search = trimmedSearch;
    }

      if (this.selectedSpaceType) {
      queryparams.spaceType = this.selectedSpaceType;
    }

    if (this.selectedServiceArea) {
      queryparams.serviceArea = this.selectedServiceArea;
    }

    if (this.selectedStatus === 'pending' && this.selectedPendingStatus) {
      queryparams.pendingStatus = this.selectedPendingStatus;
    }
    
    this.tripService.getAllTrips(queryparams).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.trips = data.results;
          this.filterdataList = this.trips;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }


  getPageCount() {
    const length = this.filterdataList.length;
    const count = (this.numberOfRecords * this.currentPage) - (length !== this.numberOfRecords ? (this.numberOfRecords - length) : 0);
    return `${count} of ${this.totalResults}`;
  }


  onSelectTrip(trip: any) {
    const index = this.selectedTrips.findIndex((t: any) => t.id === trip.id); // Check if trip is already selected
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
      if (!this.selectedTrips.length) {
        this.isDropdownOpen = false;
      }
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip);
      if (this.selectedTrips.length) {
        this.isDropdownOpen = true;
      }
    }

  }

  reRouteTrip(trip: any) {
    this.source = 'reroute'
    this.singleTrip = [trip];
    this.isMultiCancelModal = true;
  }

  onSelectAllTrips(event: any) {
    const checked = event.target.checked;
    this.filterdataList.forEach((trip: any) => trip.isSelected = checked);
    this.selectedTrips = checked ? [...this.filterdataList] : [];
    if (this.selectedTrips.length) {
      this.isDropdownOpen = true;

    } else {
      this.isDropdownOpen = false;
    }

  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips(this.currentPage);
    this.clearMemberData();

  }

  toggleItemsPerPageDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isItemsPerPageOpen = !this.isItemsPerPageOpen;
  }

  closeItemsPerPageDropdown() {
    this.isItemsPerPageOpen = false;
  }

  onLimitChange(limit: number) {
    this.isItemsPerPageOpen = false;
    if (this.numberOfRecords === limit) {
      return;
    }
    this.numberOfRecords = limit;
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  opendetailModal(trip: any) {
    this.tripId = trip.id;
  }

  raiseTicket(trip: any) {
    this.ticketTripId = trip.id;
  }

  openDistributionModal(evt?: any) {
    if (evt) {
      this.selectedTrips = [evt];
    } else {
      this.selectedTrips = this.trips.filter((trip: any) => trip.isSelected);
    }
    this.isDistributionModal = true;
  }

  closeModal() {
    this.isDistributionModal = false;
    if (this.singleTrip) {
      this.singleTrip = null;
    }
  }

  openMultiCancelModal(mySource:any) {
    this.source = mySource;
    this.isMultiCancelModal = true;
  }

  closeMultiCancelModal() {
    this.isMultiCancelModal = false;
    if (this.singleTrip) {
      this.singleTrip = null;
    }
  }

  openCancelModal(trip:any){
    this.cancelTripObj = trip;
  }
  openLogModal(trip:any){
    this.logObj = trip.id;
  }
  relationLegModal(trip: any) {
    this.relationLegObj = trip.id;
  }

  onCancelTrip(evt: any[]) {
    if (evt.length) {
      this.trips = this.trips.filter(
        (trip: any) => !evt.includes(trip.id)
      );
      this.filterdataList = [...this.trips];
      if (
        this.filterdataList.length === 0 &&
        this.currentPage < this.totalPages
      ) {
        this.getAllTrips(this.currentPage);
      }       
    }
    this.singleTrip = null;
    this.cancelTripObj = null;
    this.isDropdownOpen = false;
    this.selectedTrips = [];
    this.uncheckTrips();
  }

  onUpdateTrip(evt: any) {
    const selectedTrips = this.selectedTrips.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
    let index;
    for (let item of evt.tripsIds) {
      index = this.trips.findIndex((trip: any) => trip.id === item)
      let modifiedTrip = selectedTrips[item]
      if (evt.source === 'assign') {
        if (selectedTrips[item].company && this.selectedStatus === 'offered') {
          modifiedTrip = {
            ...modifiedTrip,
            company: evt.company
          }
          this.trips[index] = modifiedTrip;
        } else {
          this.trips.splice(index, 1)
        }
      }
      else {
        this.trips.splice(index, 1)
      }
      this.filterdataList = [...this.trips];
    } 
    if (
      this.filterdataList.length === 0 &&
      this.currentPage < this.totalPages
    ) {
      this.getAllTrips(this.currentPage);
    } 
    this.isDistributionModal = false;
    this.isDropdownOpen = false;
    this.selectedTrips = [];
    this.uncheckTrips();
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
     this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  filterTrips(status?: any) {
    if (['scheduled', 'pending', 'marketplace'].includes(status)) {
      this.selectedCompany = '';
    }
    if (!['pending', 'marketplace','completed','cancelled'].includes(status)) {
      this.selectedFundingSource = '';
    }
    this.currentPage = 1
    this.selectedStatus = status || '';
    this.getAllTrips(this.currentPage);
    this.router.navigate([], {
      relativeTo: this.route,
      fragment: status
    });
  }

  clear(){
    this.trips = []
    this.selectedTrips = [];
    // this.trip.isSelected = false;
  }

  onCompanyChange(){
    this.currentPage = 1
    this.getAllTrips(this.currentPage);
  }

  onServiceAreaChange(){
    this.currentPage = 1
    this.getAllTrips(this.currentPage);
    // this.onSearchData();
  }
  onPendingStatusChange(){
    this.currentPage = 1
    this.getAllTrips(this.currentPage);
  }
  onSpaceTypeChange(){
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onFundingSourceChange() {
    this.getAllTrips(this.currentPage);
  }

 

  openNotesModal(memberNotes: any) {
    this.memberNotesObj = memberNotes;
  }

  sendtoMarketPlace(event: any, index: any) {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trip to marketplace",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          selectedIds: [event.id],
          company: null,
          status: "marketplace"
        };
        this.apiRequest(payload, [event.id]);
      }
    });
  }

  sendBulktoMarketPlace() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trips to marketplace",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const selectedTripIds = this.selectedTrips.map((trip: any) => trip.id);
        const payload = {
          selectedIds: selectedTripIds,
          company: null,
          status: "marketplace"
        };
        this.apiRequest(payload, selectedTripIds);
        this.selectedTrips = [];
      }
    });

  }

  apiRequest(payload: any, selectedTripIds: any) {
    this.tripService.sendtoMarketPlace(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        selectedTripIds.forEach((id: number) => {
          const index = this.filterdataList.findIndex((trip: any) => trip.id === id);
          if (index !== -1) {
            this.filterdataList.splice(index, 1);
          }
          this.closeActionMenu(null);
        });
        if (
          this.filterdataList.length === 0 &&
          this.currentPage < this.totalPages
        ) {
          this.getAllTrips(this.currentPage);
        } 
      }
    });
  }

  backtoSchedule(event: any, index: any,) {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trip to schedule",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          selectedIds: [event.id],
          company: null,
          status: "scheduled"
        };
        this.apiRequest(payload, [event.id]);
      }
    });
  }

  bulkBacktoSchedule() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trips to schedule",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const selectedTripIds = this.selectedTrips.map((trip: any) => trip.id);
        const payload = {
          selectedIds: selectedTripIds,
          company: null,
          status: "scheduled"
        };
        this.apiRequest(payload, selectedTripIds);
      }
    });

  }

  autoDistribute(event?: any) {
    sweetAlert(
      "Alert",
      "Are you sure you want to auto distribute trip",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {

       const payload = {
        pre : this.selectedTrips && this.selectedTrips.length? this.preTripCompany() : [{company: event.company, tripId: event.id}],
        selectedIds: this.selectedTrips && this.selectedTrips.length ? this.selectedTrips.map((trip: any) => trip.id) : [event.id],
       };
       this.tripService.autoDistribute(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
         if (data) {
          let skippedTripsIds: any;
          const {statusUpdate} = data;
          const {skippedTrips} = statusUpdate;

          if (skippedTrips && skippedTrips.length) {
            skippedTripsIds = skippedTrips;
          }

          const tripIds = skippedTripsIds ? this.selectedTrips.filter((tripId: any) => !skippedTripsIds.includes(tripId)) : this.selectedTrips

          for (let id of tripIds) {
            const idx = this.trips.findIndex((trip: any) => trip.id === id);
            const trip = this.trips[idx];
            if (trip.company) {
            } else {
              this.trips.splice(idx, 1);
            }
          }

          if(data.statusUpdate)
           sweetAlert("Alert", data.statusUpdate.message, "alert", "OK");
         }
       });
       
      }
    });

  }
  preTripCompany() {
    const previousAssignedCompanies = this.selectedTrips
      .filter((trip: any) => trip.company)
      .map((trip: any) => ({
        company: trip.company,
        tripId: trip.id
      }));
      return previousAssignedCompanies;
  }

  showActionButtons(idx:any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt:any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

   closeFilterDropDown(evt:any) {
    this.isDropdownOpen = false
  }


  //  closeMenu(evt:any) {
  //   this.isDropdownOpen = false;
  // }

 
editTrip(evt: any) {
  if (this.selectedStatus === 'all') {
    this.router.navigate(
      [`trips/${evt.id}/edit`],
      { state: { section: 'all' } }
    );
  } else {
    this.router.navigate([`trips/${evt.id}/edit`]);
  }
} 
toggleDropdown(event: MouseEvent) {
    this.isDropdownOpen = !this.isDropdownOpen;
  }


  // getAllMembers() {
  //   let queryParams = {
  //     limit: 9999,
  //     isActive: true,
  //   }
  //   this.memberService.getPickerMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
  //     if (data && data.results) {
  //       this.members = data.results.map((member: any) => ({
  //         ...member,
  //         fullName: `${member.firstName} ${member.lastName}`.trim()
  //       }))
  //     }
  //   })
  // }

  getAllMembers() {
    const queryParams: any = {
      limit: 10,
      page: this.memberPageNumber,
      isActive: true,

    }
    this.memberService.getPickerMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.members = [...this.members, ...data.results];
        this.memberPageNumber += 1;
      }
    })
  }

  onMembersChange(evt:any){
    this.selectedMembers = evt;
     this.getAllTrips(this.currentPage = 1);
      // this.onSearchData()
    // if (this.selectedMembers) {
    //   this.filterdataList = this.trips.filter((trip: any) =>
    //     trip.member?.id === this.selectedMembers
    //   );
    // } else {
    //   this.filterdataList = this.trips;
    // }
  }

  getFundingSources() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.fundingSourceService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
          this.preFundingSource = this.fundingSources.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getSelectedTrips() {
    return this.trips
      .filter((trip: any) => trip.isSelected);
  }



  ngOnDestroy(): void {
  }

  uncheckTrips() {
    this.trips.forEach((trip: any) => trip.isSelected = false);
  }

  assignSingleTrip(trip: any) {
    this.singleTrip = [trip];
    this.isDistributionModal = true;
  }

  onAssignSingleTrip(evt: any) {
    const singleTrip = this.singleTrip[0];
    const idx = this.trips.findIndex((trip: any) => trip.id === singleTrip.id);

    if (evt && evt.tripsIds && evt.tripsIds.includes(singleTrip.id)) { 
      if (evt.source === 'assign' && singleTrip.company && this.selectedStatus === 'offered') {
        // Reassign
        this.trips[idx].company = evt.company;
      } else {
        // Assign/Unassign
        this.trips.splice(idx, 1);
      }
    }

    this.singleTrip = null;
    this.isDistributionModal = false;
    this.isDropdownOpen = false;
    this.selectedTrips = [];
    this.uncheckTrips();
  }

  openAutoDistributionModal(event?:any){
    this.isAutoDistributionModal = true
    if(event){
    this.singleTrip = [event];
    }
  }

  closeAutoDistributionModal(){
    this.singleTrip = null;
    this.isAutoDistributionModal = false;
    this.getAllTrips(this.currentPage);
  }

  cancelSignleTrip(trip: any) {
    this.source = 'cancel'
    this.singleTrip = [trip];
    this.isMultiCancelModal = true;
  }
  
  filterTripsByModel() {
    this.filterdataList = this.trips;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    )
  }

  openAdjustTrip(event: any) {
    if (this.selectedStatus === 'all') {
      this.router.navigate(
        [`trips/vendor/${event.id}/adjustTrip`],
        { state: { section: 'all' } }
      );
    } else {
      this.router.navigateByUrl(`trips/vendor/${event.id}/adjustTrip`);
    }
  }

  openAdjustFundingSourceTrip(event: any) {
    if (this.selectedStatus === 'all') {
      this.router.navigate(
        [`trips/fundingsource/${event.id}/adjustTrip`],
        { state: { section: 'all' } }
      );
    } else {
      this.router.navigateByUrl(`trips/fundingsource/${event.id}/adjustTrip`);
    }
  }

  openTripTrails(trip: any) {
    this.tripTrailId = trip.id;

  }


  onScroll() {
    if (this.memberSearchQuery) {
      this.memberSearch(this.memberSearchQuery);
    } else {
      this.getAllMembers();
    }
  }

   onSearch(event: any) {
      const { term } = event;
      if (term) {
        this.memberSearchSubject.next(term);
      } else {
        this.clearSearh();
      }
    }

  clearSearh() {
    this.memberSearchQuery = '';
    this.memberSearchPageNumber = 1;
    this.members = [];
    this.memberPageNumber = 1
    this.getAllMembers();
  }

  
  listenMemberSearch() {
      this.memberSearchSubject
        .pipe(debounceTime(1000))
        .pipe(untilDestroyed(this)).subscribe((search) => {
          this.memberSearchQuery = search;
          if (search && search.length >= 3) {
            this.members = [];
            this.memberSearchPageNumber = 1;
            this.memberSearch(search);
          }
        });
    }
  
    memberSearch(search: any, id = null) {
      const queryParams: any = {
        limit: 10,
        page: this.memberSearchPageNumber
      }
  
      if (search) {
        queryParams.search = search;
      }
  
      if (id) {
        queryParams.id = id;
      }
  
      if (!this.tripId) {
        queryParams.isActive = true;
      }
  
      this.memberService.searchMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.members = [...this.members, ...data.results];
          this.memberSearchPageNumber += 1;
        }
      });
    }
  onClear() {
    if (this.memberSearchQuery) {
      this.clearSearh();
      this.clearMemberData();
    }
  }

  clearMemberData() {
    this.selectedMembers = '';
  }


  onClose() {
    if (!this.selectedMembers && this.memberSearchQuery) {
      this.clearSearh();
    }
  }

  archiveTrip(trip:any){
    sweetAlert(
      "Alert",
      "Are you sure you want to archive trip",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload: any = {
          selectedIds: [trip.id],
          status: "archived"
        };
        this.sendToArchive(payload, [trip.id]);
      }
    });
  }

  getBackFromArchive(trip:any,index: any){
    sweetAlert(
      "Alert",
      "Are you sure you want to un archive trip",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload: any = {
          selectedIds: [trip.id],
          company: null,
          driver: null,
          status: "scheduled"
        };
        this.sendToArchive(payload, [trip.id]);
        this.selectedTrips = [];
      }
    });
  }

  sendBulktoArchieve() {
    sweetAlert(
      "Alert",
      "Are you sure you want to archive trips",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const selectedTripIds = this.selectedTrips.map((trip: any) => trip.id);
        const payload = {
          selectedIds: selectedTripIds,
          company: null,
          driver: null,
          status: "archived"
        };
        this.sendToArchive(payload, selectedTripIds);
        this.selectedTrips = [];
      }
    });

  }

  sendToArchive(payload: any,selectedTrips:any) {
    this.tripService.assignToCompany(payload).pipe(untilDestroyed(this)).subscribe({
      next: (res: any) => {
        if (res) {
          selectedTrips.forEach((id: number) => {
            const index = this.filterdataList.findIndex((trip: any) => trip.id === id);
            if (index !== -1) {
              this.filterdataList.splice(index, 1);
            }
            this.closeActionMenu(null);
            if (res.statusUpdate) {
              sweetAlert("Alert", res.statusUpdate.message, "alert", "OK");
            }
          });
          if (
            this.filterdataList.length === 0 &&
            this.currentPage < this.totalPages
          ) {
            this.getAllTrips(this.currentPage);
          } 
        }

        
      }
    },)
  }

  bulkBacktoScheduleFromArchive() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trips to schedule",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const selectedTripIds = this.selectedTrips.map((trip: any) => trip.id);
        const payload = {
          selectedIds: selectedTripIds,
          company: null,
          driver: null,
          status: "scheduled"
        };
        this.sendToArchive(payload, selectedTripIds);
      }
    });

  }

  updateJob(assign: any, assignKey: any) {
    const updatedValue = !assign.flags[assignKey];
    console.log('updatedValue', updatedValue);
    
    assign.flags[assignKey] = updatedValue;
    let payload = { [assignKey]: updatedValue } as any ;

    if (assignKey === 'isWillCallActivated') {
      payload.isWillCall = true;
      assign.flags.isWillCall = true;
    }

    console.log('payload', payload);
  
    this.tripService.updateTrip(payload, assign.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        sweetAlert("Alert", "Trip updated successfully", "success", "OK");
        this.closeActionMenu({});
      }
    });
  }

  cloneTrip(trip:any){
    this.tripService.cloneTrip(trip.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        sweetAlert("Alert", "Trip cloned successfully", "success", "OK");
        this.closeActionMenu({});

      }
    })
  }

  showMultiTime(evt:any){
    this.isShowTime = evt
  }

 initializeSearch() {
  this.searchSubject
    .pipe(
      debounceTime(500), // wait for typing to stop
      filter(search => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
    ).subscribe(() => {
      this.currentPage = 1;
      this.getAllTrips(this.currentPage);
    });
  }

  onSearchInput() {
  this.searchSubject.next(this.search);
}


  // onSearchData() {
  //   const queryParams: any = {
  //     limit: 50,
  //     status: this.selectedStatus,
  //     time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
  //     sortBy: 'pickup.time:asc',
  //   };

  //   if (this.search) {
  //     const rawSearch = this.search.replace(/\D/g, ''); 
  //     queryParams.search = rawSearch || this.search;
  //   }

  //   if (this.selectedSpaceType) {
  //     queryParams.spaceType = this.selectedSpaceType;
  //   }

  //   if (this.selectedServiceArea) {
  //     queryParams.serviceArea = this.selectedServiceArea;
  //   }
  //   if (this.selectedMembers) {
  //     queryParams.member = this.selectedMembers;
  //   }

  //   this.tripService.searchTrips(queryParams).subscribe((data: any) => {
  //     if (data) {
  //       this.filterdataList = [...data.results];
  //       this.totalPages = data.totalPages;
  //       this.totalResults = data.totalResults;
  //     }
  //   });
  // }

  openSignatureModal(trip: any) {
    this.signatureModalObj = trip;
  }

  openWillCallModal(trip: any, evt:any) {
    this.willCallTrip = trip;
    this.willCallModal = true;
  }

  onCloseSignatureModal(evt: any) {
    if (evt) {
      this.signatureModalObj.signature = evt.signature;
    }
    this.signatureModalObj = null;
  }

   onCloseWillCallModal(evt: any) {
    this.willCallModal = false;
  }

  updateWillCalltrip(payload: any) {

  const willCallNotes = payload.willCallNotes?.trim();

  const existingNotes = this.willCallTrip.generalNotes?.trim() ?? '';

  if (willCallNotes) {
    payload.generalNotes = existingNotes ? `${existingNotes}\nWill Call Notes:\n${willCallNotes}` : `Will Call Notes:\n${willCallNotes}`;
  } else {
    payload.generalNotes = existingNotes;
  }

    if (payload.flags?.isWillCallActivated) {
      payload.flags.isWillCall = false;
    } else {
      payload.flags.isWillCall = true;
    }

    this.tripService.createTrip(payload, this.willCallTrip.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        const index = this.filterdataList.findIndex((t: any) => t.id === data.id);
        if (index !== -1) {
          this.filterdataList[index].flags.isWillCallActivated = data.flags.isWillCallActivated;
          this.filterdataList[index].flags.isWillCall = data.flags.isWillCall;
          this.filterdataList[index].pickup.time = data.pickup.time;
          this.filterdataList[index].destination.time = data.destination.time;
          this.filterdataList[index].generalNotes = data.generalNotes
        }
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "Ok");
    }
    )
  }

  breakString(str: any) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  async sendToSchedule(singleTrip?: any) {
    // it handled both single and bulk trip scheduling
    let selectedIds: any = [];
    if (singleTrip) {
      selectedIds = [singleTrip.id];
    } else {
      selectedIds = this.selectedTrips
      .filter((trip: any) => ['initiated', 're-offered'].includes(trip.pendingStatus))
      .map((trip: any) => trip.id);
    }

    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to send ${singleTrip ? "this trip" : "these trips"} to scheduled?`,
      "warning",
      "Yes",
      "No"
    );
    if (result.value) {
      const payload = {
        status: 'accepted',
        selectedIds: selectedIds
      }
      this.tripService
        .updatePendingTripStatus(payload)
        .pipe(untilDestroyed(this))
        .subscribe((data: any) => {
          if (data) {
            const { statusUpdate } = data;
            const { skippedTrips } = statusUpdate;
            if (singleTrip && !skippedTrips.includes(singleTrip.id)) {
              const index = this.filterdataList.findIndex((trip: any) => trip.id === singleTrip.id);
              if (index > -1) {
                this.filterdataList.splice(index, 1);
              }
            } else {
              for (let i = this.filterdataList.length - 1; i >= 0; i--) {
                const tripId = this.filterdataList[i].id;
                if (selectedIds.includes(tripId) && !skippedTrips.includes(tripId)) {
                  this.filterdataList.splice(i, 1);
                }
              }
              this.isDropdownOpen = false;
              this.selectedTrips = [];
              this.uncheckTrips();
            }
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
    }
  }

  isPendingTripsEligibleForSchedule() {
    return this.selectedTrips.some((trip: any) => ['initiated', 're-offered'].includes(trip.pendingStatus)); 
  }

  openRejectTripModal(singleTrip?: any) {
    // it handled both single and bulk trip scheduling
    if (singleTrip) {
      this.rejectTripModalObj = {
        isBulkUpdate: false,
        tripIds: [singleTrip.id] 
      };
    } else {
      this.rejectTripModalObj = {
        isBulkUpdate: true,
        tripIds: this.selectedTrips
          .filter((trip: any) => ['initiated', 're-offered'].includes(trip.pendingStatus))
          .map((trip: any) => trip.id)
      };
    }
  }

  onCloseRejectTripModal(data: any) {
    if (data) {
      const { isBulkUpdate, tripIds } = this.rejectTripModalObj;
      const { statusUpdate, changeReasonNotes } = data;
      const { skippedTrips } = statusUpdate;
      this.filterdataList.forEach((trip: any) => {
        if (tripIds.includes(trip.id) && !skippedTrips.includes(trip.id)) {
          trip.pendingStatus = 'rejected'
          trip.changeReasonNotes = changeReasonNotes
        }
      });
      if (isBulkUpdate) {
        this.isDropdownOpen = false;
        this.selectedTrips = [];
        this.uncheckTrips();
      }
    }
    this.rejectTripModalObj = null;
  }

  isPendingTripsEligibleForReject() {
    return this.selectedTrips.some((trip: any) => ['initiated', 're-offered'].includes(trip.pendingStatus)); 
  }


  bulkFundingSourceAdjust() {
    const selectedTripIds = this.selectedTrips.filter((trip: any) =>
      ['completed', 'cancelled', 'all'].includes(this.selectedStatus)
      && (['completed'].includes(trip.status) || (trip.flags.isBillable && ['cancelled'].includes(trip.status)))
    ).map((trip: any) => trip.id);

    const payload: any = {
      selectedIds: selectedTripIds,
    };
    this.tripService.bulkFundingSourceAdjust(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if(data.success && data.success.length){
      data.success.forEach((id: string) => {
        const trip = this.filterdataList.find((t: any) => t.id === id);
        if (trip) {
          trip.fundingsourceBilling.billingStatus = 'pending';
        }
      });
      this.selectedTrips = [];
      this.filterdataList.forEach((trip: any) => trip.isSelected = false);
      sweetAlert("Alert", `Funding Source Adjustments processed successfully${data.batchId ? ` (Batch ${data.batchId})` : ''}`, "success", "OK");
    }
      }
    });
  }

  bulkVendorAdjust(){
    const selectedTripIds = this.selectedTrips.filter((trip: any) =>
       ['completed','cancelled','all' ].includes(this.selectedStatus) 
    && (['completed' ].includes(trip.status) || (trip.flags.isBillable && ['cancelled' ].includes(trip.status)))
  ).map((trip: any) => trip.id);

    const payload: any = {
      selectedIds: selectedTripIds,
    };
    this.tripService.bulkVendorAdjust(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if(data.success && data.success.length){
        data.success.forEach((id: string) => {
          const trip = this.filterdataList.find((t: any) => t.id === id);
          if (trip) {
            trip.billing.billingStatus = 'pending';
          }
        });
        this.selectedTrips = [];
        this.filterdataList.forEach((trip: any) => trip.isSelected = false);
        sweetAlert("Alert", `Vendor Adjustments processed successfully${data.batchId ? ` (Batch ${data.batchId})` : ''}`, "success", "OK");
      }

      }
    });
  }

  getDateRangeWiseTrips() {
    const queryParams : any = {
      limit: 9999,
      status: this.selectedStatus,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    }
    if (this.selectedStatus === 'all') {
      queryParams.status = [
        'pending',
        'scheduled',
        'offered',
        'completed',
        'cancelled',
        'onway',
        'arrived',
        'in_progress',
        'marketplace',
        'reroute'
      ];
    } else {
      queryParams.status = this.selectedStatus;
    }
    if (this.selectedCompany) {
      queryParams.company = this.selectedCompany;
    }

    if (this.selectedMembers) {
      queryParams.member = this.selectedMembers;
    }

    if (this.search) {
      console.log('this.search',this.search);
      const trimmedSearch = this.search.trim();
      queryParams.search = trimmedSearch;
    }

    if (this.selectedSpaceType) {
      queryParams.spaceType = this.selectedSpaceType;
    }

    if (this.selectedServiceArea) {
      queryParams.serviceArea = this.selectedServiceArea;
    }

    if (this.selectedFundingSource) {
      queryParams.fundingsource = this.selectedFundingSource;
    }

    if (this.selectedStatus === 'pending' && this.selectedPendingStatus) {
      queryParams.pendingStatus = this.selectedPendingStatus;
    }
    if (this.selectedTrips?.length) {
      this.csvService.generateTripReport(
        this.selectedTrips,
        this.todayDate,
        this.timeZone,
        this.preServiceAreas,
        this.preLevelOfService,
        this.preSpacetypes,
        this.preFundingSource
      );
    } else {
      this.tripService.getTripsReport(queryParams)
        .pipe(untilDestroyed(this))
        .subscribe((data: any) => {
          if (data && data.results) {
            this.csvService.generateTripReport(data.results, this.todayDate, this.timeZone
              )
          }
        });
    }
  }

  async markComplete(trip?: any) {

    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to force complete?`,
      "warning",
      "Yes",
      "No"
    );

    if (result.value) {
      const selectedIds = trip ? [trip.id] : (this.selectedTrips?.map((t: any) => t.id) || []);

      const payload = {
        selectedIds,
        status: "completed",
      };

      this.tripService.tripStatusForceUpdate(payload).pipe(untilDestroyed(this)).subscribe({
        next: (res: any) => {
          if (res && selectedIds.length) {
            this.filterdataList = this.filterdataList.filter(
              (t: any) => !selectedIds.includes(t.id)
            );
            this.selectedTrips = [];
            this.filterdataList.forEach((trip: any) => trip.isSelected = false);
          }
            if (
              this.filterdataList.length === 0 &&
              this.currentPage < this.totalPages
            ) {
              console.log("first", this.filterdataList.length);
              this.getAllTrips(this.currentPage);
            }
        },
        error: (err) => {
          console.error("Failed to update trip status", err);
        }
      });
    }
  }

    markCancel(trip?: any) {

    const selectedIds = trip ? [trip.id] : (this.selectedTrips?.map((t: any) => t.id) || []);
    
    const payload = {
      selectedIds,
      status: "cancelled",
    };

    this.tripService.tripStatusForceUpdate(payload).pipe(untilDestroyed(this)).subscribe({
      next: (res: any) => {
        if (res && selectedIds.length) {
          this.filterdataList = this.filterdataList.filter(
            (t: any) => !selectedIds.includes(t.id)
          );
        this.selectedTrips = [];
        this.filterdataList.forEach((trip: any) => trip.isSelected = false);
        }
      },
      error: (err) => {
        console.error("Failed to update trip status", err);
      }
    });
  }
  
  async chargePayment(trip: any) {
    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to charge payment for this trip?`,
      "warning",
      "Yes",
      "No"
    );
    if (result.value) {
      this.paymentsService.chargePayment(trip.id).pipe(untilDestroyed(this)).subscribe({
        next: (res: any) => {
          if (res) {
            sweetAlert("Alert", "Payment charged successfully", "success", "OK");
          }
        },
        error: (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      });
    }

  }

  async generatePaymentLink(trip: any) {
    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to generate payment link for this trip?`,
      "warning",
      "Yes",
      "No"
    );
    if (result.value) {
      this.paymentsService.generatePaymentLink(trip.id).pipe(untilDestroyed(this)).subscribe({
        next: (res: any) => {
          if (res) {
            sweetAlert("Alert", "Payment link generated successfully", "success", "OK");
          }
        },
        error: (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      });
    }
  }
  async updatePayment(trip: any, data: any) {

    let payload: any = {
      isFullPaid: data.isFullPaid,
      isPartiallyPaid: data.isPartiallyPaid
    };

    const actionMessage =
      data.isFullPaid
        ? 'mark as fully paid'
        : data.isPartiallyPaid
          ? 'mark as partially paid'
          : 'unmark payment';
    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to ${actionMessage}?`,
      "warning",
      "Yes",
      "No"
    );

    if (result.value) {

      this.tripService.updateTrip(payload, trip.id).pipe(untilDestroyed(this)).subscribe({
        next: (res: any) => {
          this.filterdataList = this.filterdataList.map((t: any) => {
            if (t.id === trip.id) {
              return {
                ...t,
                flags: {
                  ...t.flags,
                  isFullPaid: payload.isFullPaid,
                  isPartiallyPaid: payload.isPartiallyPaid
                }
              };
            }
            return t;
          });
        },
        error: (err) => {
          console.error("Failed to update trip status", err);
        }
      });
    }
  }

  isReserved(trip: any): boolean {
    const expiresAt = trip?.reserved?.expiresAt;

    if (!expiresAt) {
      return false;
    }

    const expiryTime = moment(expiresAt);

    if (!expiryTime.isValid()) {
      return false;
    }

    return moment().isBefore(expiryTime);
  }

}
